import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const formatPrice = (price) => {
    return price && price > 0 ? `₹${Number(price).toFixed(2)}` : 'Price not available';
};

const ProductCard = ({ product }) => {
    const navigate = useNavigate();
    const [isImageLoaded, setIsImageLoaded] = useState(false);

    const discountPercent = product.super_price && product.mrp ? 
        Math.round(((product.mrp - product.super_price) / product.mrp) * 100) : 
        product.discount || 0;

    return (
        <>
            <div
                className="group relative bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 ease-in-out cursor-pointer"
                onClick={() => navigate(`/product/${product._id}`)}
            >
                {/* Discount Badge - Only show if there's a valid discount */}
                {discountPercent > 0 && product.super_price > 0 && (
                    <div className="absolute top-3 left-3 z-10">
                        <div className="bg-red-500 text-white text-xs font-bold px-2 py-1 rounded-full">
                            {discountPercent}% OFF
                        </div>
                    </div>
                )}

                {/* Image Container */}
                <div className="relative aspect-square overflow-hidden bg-gray-100">
                    {product.imageUrl ? (
                        <img
                            src={product.imageUrl}
                            alt={product.name}
                            className={`w-full h-full object-cover transform transition-transform duration-300 group-hover:scale-105 ${
                                isImageLoaded ? 'opacity-100' : 'opacity-0'
                            }`}
                            onLoad={() => setIsImageLoaded(true)}
                            onError={() => {
                                // Image failed to load - show no image placeholder
                                setIsImageLoaded(false);
                            }}
                        />
                    ) : null}
                    {(!product.imageUrl || !isImageLoaded) && (
                        <div className="absolute inset-0 flex flex-col items-center justify-center bg-gray-200">
                            <svg 
                                className="w-16 h-16 text-gray-400 mb-2" 
                                fill="none" 
                                viewBox="0 0 24 24" 
                                stroke="currentColor"
                            >
                                <path 
                                    strokeLinecap="round" 
                                    strokeLinejoin="round" 
                                    strokeWidth={2} 
                                    d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" 
                                />
                            </svg>
                            <p className="text-sm text-gray-500">No Image</p>
                        </div>
                    )}
                </div>

                {/* Product Info */}
                <div className="p-4">
                    <h3 className="text-sm font-medium text-gray-700 line-clamp-2 mb-2 group-hover:text-blue-600 transition-colors">
                        {product.name}
                    </h3>
                    
                    <div className="space-y-1">
                        <div className="flex items-baseline gap-2">
                            <span className={`text-lg font-bold ${product.super_price > 0 ? 'text-gray-900' : 'text-gray-500'}`}>
                                {formatPrice(product.super_price)}
                            </span>
                            {product.mrp > product.super_price && product.super_price > 0 && (
                                <span className="text-sm text-gray-500 line-through">
                                    ₹{Number(product.mrp).toFixed(2)}
                                </span>
                            )}
                        </div>
                        
                        {/* Additional Info - removed stock status */}
                        <div className="text-xs text-gray-500">
                            {product.category}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ProductCard;